import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import sqsAddReport from "../services/AddSqsService";

import { updateCulture } from "../store/culture/action";
import { getContentItem } from "../services/KenticoService";

const KenticoLoaderComponent = (props) => {
  const { country, language, orgcode, token, email } = useParams();
  const [validaUrl, setValidaUrl] = useState("true");

  const validar = useCallback(async () => {
    const result = await sqsAddReport.validateUrlSiteCompany(
      orgcode,
      token,
      email
    );
    setValidaUrl(result.data.status);
  }, []);

  useEffect(() => {
    validar();

    const validateAndSet = async () => {
      const landingData = await getContentItem(
        "companies_reports",
        `${language}_${country}`
      );

      const publishOptions = landingData.item.elements.publish_options.value[0];
      const isCultureVisible =
        landingData.linkedItems[publishOptions].elements.visible.value[0]
          .codename;

      const headerData = await getContentItem(
        "header",
        `${language}_${country}`
      );

      const footerData = await getContentItem(
        "footer",
        `${language}_${country}`
      );

      const stationsData = await getContentItem(
        "stations",
        `${language}_${country}`
      );

      props.updateCulture({
        country,
        language,
        url: `/${country}/${language}`,
        culture: `${language}_${country}`,
        elements: landingData.item.elements,
        modular: landingData.linkedItems,
        loader: true,
        headerData,
        footerData,
        stationsData,
        orgcode,
        token,
        email,
        valida: validaUrl,
        isCultureVisible,
      });

      return <div></div>;
    };

    country && language && validateAndSet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, language, validaUrl, validar]);

  return <></>;
};

export default connect(null, { updateCulture })(KenticoLoaderComponent);
